import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';

export const NO_CREDIT_PROVISIONS = ['creditProvision'];

export const PRODUCT_HIDDEN_SECTIONS = new Map<string, string[]>([
  [ProductTypeEnum.AUTOCALL, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.AUTOCALL_GROWTH_AT_MATURITY, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.BONUS_CERTIFICATE, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.CAPPED_FLOOR_DELTA_N, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.CHOOSER, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.CLN, ['']],
  [ProductTypeEnum.DISCOUNT_CERTIFICATE, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.DUAL_CURRENCY_NOTE, NO_CREDIT_PROVISIONS],
  [
    ProductTypeEnum.FIXED_TO_FLOATING_FLOATING_TO_FIXED_RATE_NOTE,
    NO_CREDIT_PROVISIONS,
  ],
  [ProductTypeEnum.FLOATING_RATE_NOTE, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.FIXED_RATE_NOTE, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.EQ_ISSUER_CALLABLE, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.PARTICIPATION_NOTE, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.PERFORMANCE_LINKED_COUPON, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.PRDC, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.RANGE_ACCRUAL_EQ, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.RANGE_ACCRUAL_RATES, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.REVERSE_CONVERTIBLE, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.SUPERTRACKER, NO_CREDIT_PROVISIONS],
  [ProductTypeEnum.TARGET_REDEMPTION_EQ, NO_CREDIT_PROVISIONS],
]);
